module.exports = __webpack_public_path__ + "img/line.png";